import { Icon, type IconTone } from './Icon';

/** Есть ссылка на источник: два звена цепи. */
export function LinkIcon({
  size,
  label,
  tone,
}: {
  size?: number;
  label?: string;
  tone?: IconTone;
}) {
  return (
    <Icon size={size} label={label} tone={tone}>
      <path d="M5.7 8.3 L8.3 5.7" />
      <path d="M7.7 4 L9.1 2.6a2.7 2.7 0 0 1 3.7 3.7L11.4 7.7" />
      <path d="M6.3 10 L4.9 11.4a2.7 2.7 0 0 1-3.7-3.7L2.6 6.3" />
    </Icon>
  );
}
